module.exports = __webpack_public_path__ + "static/media/faqsimage.b5590af3.svg";